import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"

import type { AppletSuccessApplet, UIEvent } from "../types"
import styles from "./applet_success_card.module.scss"

interface Props {
  ui: UIEvent
  username: string
}

function adaptApplet(applet: AppletSuccessApplet, username: string) {
  const channels = applet.services.map(s => ({
    module_name: s.value,
    name: s.label,
    monochrome_image_url: s.icon_url,
    brand_color: s.brand_color,
  }))
  return {
    id: applet.slug,
    name: applet.title,
    description: "",
    channels,
    service_slug: channels[0]?.module_name,
    status: "enabled_for_user",
    author: username,
    by_service_owner: false,
    brand_color: channels[0]?.brand_color,
  }
}

const AppletSuccessCard = ({ ui, username }: Props) => {
  const applet = ui.data.applet as AppletSuccessApplet | undefined

  if (!applet?.applet_url || !applet.title || !applet.services?.[0]) {
    return (
      <div className={styles["row"]}>
        <div className={styles["fallback"]}>{ui.fallback_text || `(${ui.type})`}</div>
      </div>
    )
  }

  return (
    <div className={styles["row"]}>
      <div className="web-applet-card">
        <SmallAppletCard
          applet={adaptApplet(applet, username)}
          appletPath={applet.applet_url}
          extraClass="sized-applet-card-small"
        />
      </div>
    </div>
  )
}

export default AppletSuccessCard
